import styled from 'styled-components';

import Text from '@Components/atoms/Text';
import { LineHeight } from '@Components/molecules/WordBoxWordWrap/WordBoxWordWrap.styles';

import { TypingTestFontSize } from '@Helpers/types/typing-test';

import { UserSelectNone } from '@Assets/styles/theme/mixins';

interface HiddenInputProps {
  readonly $fontSize: TypingTestFontSize;
  readonly $offsetTop: number;
  readonly $offsetLeft: number;
  readonly $inputWidth: number;
}

export const InactiveBanner = styled.div`
  z-index: 10;
  position: absolute;
  width: 102%;
  height: 106%;
  top: -6px;
  left: -10px;
  animation: blur-in 0.8s linear forwards;

  @keyframes blur-in {
    from {
      backdrop-filter: blur(0px);
    }
    to {
      backdrop-filter: blur(5px);
    }
  }
`;
export const InactiveBannerInner = styled(Text)`
  padding: 0.5rem;
  position: absolute;
  width: 80%;
  left: 50%;
  top: 50%;
  transform: translateX(-50%) translateY(-50%);
`;

export const Root = styled.div`
  position: relative;
  ${() => UserSelectNone()};
  margin-top: ${(props) => props.theme.space.large_32};
  margin-bottom: ${(props) => props.theme.space.xl_64};
  // this is necessary for showInvisibleChars, which renders space as char and word breaks are unclear.
  overflow-wrap: break-word;
  hyphens: manual;
  hyphenate-character: '';

  &.word-box-focused ${InactiveBanner} {
    display: none;
  }

  &:active ${InactiveBanner} {
    display: none;
  }
`;

// This must be a textarea, because an input does not trigger an onChange on an the "enter" key.
// Since we also want to end a word with the enter key, we need this.
// onKeyDown would also work, but collides with the composing,
// because sometimes letters can also be set with enter via the composing dialog without the word being ended
export const HiddenInput = styled.textarea<HiddenInputProps>`
  position: absolute;
  cursor: default;
  opacity: 0;
  caret-color: transparent;
  z-index: -1;
  resize: none;
  overflow: hidden;
  white-space: nowrap;
  height: ${(props) => `calc(${handleFontSize(props.$fontSize)} * ${LineHeight})`};
  line-height: ${LineHeight};
  top: ${(props) => props.$offsetTop}px;
  left: ${(props) => props.$offsetLeft}px;
  min-width: 1rem;
  width: ${(props) => props.$inputWidth}px;
  transform: translateY(-100%);

  font-size: ${(props) => handleFontSize(props.$fontSize)};

  @media (max-width: ${(props) => props.theme.device.tablet}) {
    font-size: ${(props) => handleFontSize(props.$fontSize, true)};
  }
`;

export const handleFontSize = (size: TypingTestFontSize, isMobile = false) => {
  switch (size) {
    case TypingTestFontSize.VerySmall:
      return isMobile ? '14px' : '16px';
    case TypingTestFontSize.Small:
      return isMobile ? '18px' : '22px';
    case TypingTestFontSize.Medium:
      return isMobile ? '22px' : '30px';
    case TypingTestFontSize.Large:
      return isMobile ? '26px' : '36px';
    case TypingTestFontSize.VeryLarge:
      return isMobile ? '30px' : '42px';
    default:
      return '16px';
  }
};
